module.exports = "https://vote4-campaigns-cdn.fire-emblem-heroes.com/images/src/assets/images/about/heroes/charactors2.png";